<template>
    <div>
        <UAccordion variant="outline" size="md" :items="FAQList" />
    </div>
</template>

<script lang="ts" setup>
import type { PropType } from "vue";
import type { IFAQ } from "~/libs/types/api/faq";

const props = defineProps({
    list: Array as PropType<IFAQ[]>,
});

const FAQList = computed(() => {
    const sortedList = useSortBy(props.list, "order");
    const list = useMap(sortedList, (el, i) => ({
        label: `${i + 1}. ${el.question}`,
        content: el.answer,
    }));
    return list;
});
</script>

<style></style>
